export default __webpack_public_path__ + "static/media/user_guide_text.e90cc5ad.svg";